import { createScopedTranslationKeys } from '@dreryk/react-common';

export const translations = {
   pl: {
      '~libs.desktop.patient-groups': {
         addCustomGroup: 'Dodaj niestandardowe oznaczenie',
         addGroup: 'Dodaj oznaczenie',
         areYouSureYouWantToRemoveGroup: 'Czy na pewno chcesz usunąć oznaczenie - <bold>{{patientGroupName}}</bold>?',
         blockRegistrationViaFollowingPortals: 'Oznaczonym pacjentom blokuj rejestrację przez poniższe portale',
         changesHaveBeenSaved: 'Zmiany zostały zapisane.',
         chosenOf: 'Wybrano {{count}} z {{totalCount}}',
         color: 'Kolor',
         customGroupAssignedTo:
            'To oznaczenie jest przypisane do <bold>{{numberAssignedPatients}} {{declensionForm}}</bold>.',
         customGroupColor: 'Kolor',
         customGroupHasBeenRemoved: 'Oznaczenie zostało usunięte.',
         customGroupHasBeenSaved: 'Oznaczenie zostało zapisane.',
         customGroupIsNotAssignedToAnyone: 'Oznaczenie nie jest przypisane do nikogo.',
         customGroupName: 'Nazwa oznaczenia pacjenta',
         customGroups: 'Oznaczenia niestandardowe',
         customPatientGroupFetchError: 'Nie udało się pobrać niestandardowego oznaczenia. Spróbuj ponownie później.',
         effect: 'Skutek',
         fillCustomGroupName: 'Uzupełnij nazwę oznaczenia...',
         name: 'Nazwa',
         noCustomGroups: 'Brak oznaczeń niestandardowych',
         noCustomGroupsHaveBeenAddedYet: 'Nie dodano jeszcze niestandardowych oznaczeń dla pacjentów.',
         noUniqueName: 'Oznaczenie o takiej nazwie już istnieje.',
         patientAccusative: 'pacjenta',
         patientEffectsMap: {
            BLOCK_CREATING_APPOINTMENTS_FROM_PATIENT_PORTAL: 'Blokowanie rejestracji przez drEryk Pacjent',
         },
         patientGenitive: 'pacjentów',
         patientGroups: 'Oznaczenia pacjenta',
         patientPlural: 'pacjentów',
         patientPortal: 'drEryk Pacjent',
         predefinedGroups: 'Oznaczenia domyślne',
         remove: 'Usuń',
         removeCustomGroup: 'Usuwasz niestandardowe oznaczenie',
         save: 'Zapisz',
         selectColorFromProvided: 'Wybierz kolor spośród podanych',
         selectGroups: 'Wybierz oznaczenia',
         updateCustomGroup: 'Edytuj niestandardowe oznaczenie',
         updateSettingsGroup: 'Edytuj ustawienia - {{groupName}}',
      },
   },
};

export const translationKeys = createScopedTranslationKeys(translations.pl, '~libs.desktop.patient-groups');
